module.exports = __webpack_public_path__ + "static/media/verysad.454a3b27.svg";